import { BackButtonService } from '~/plugins/capacitor-back-button';
export default {
    mixins: [],
    props: [],
    data() {
        return {
            showSidebar: false,
            backButtonHandler: null,
        }
    },
    computed: {},
    watch: {},
    methods: {
        openSidebar() {
            this.showSidebar = true;
            // Body-Scroll blockieren wenn Sidebar geöffnet ist
            this.blockBodyScroll();
            this.backButtonHandler = BackButtonService.addListener((canGoBack) => {
                // Modal schließen statt zurückzunavigieren
                this.closeSidebar();
                return true; // Event wurde behandelt
            }, 80);
        },
        closeSidebar() {
            this.showSidebar = false;
            // Body-Scroll wieder freigeben wenn Sidebar geschlossen ist
            this.unblockBodyScroll();
            
            // Handler entfernen
            if (this.backButtonHandler) {
                this.backButtonHandler();
                this.backButtonHandler = null;
            }
            
            // WICHTIG: Radikaler Ansatz - Entferne ALLE potenziellen Sidebar-Handler 
            // und stelle sicher, dass nur die Basis-Handler übrig bleiben
            this.$nextTick(() => {
                // console.log('Sidebar geschlossen, entferne alle Handler mit Priorität > 10');
                BackButtonService.removeListenersWithPriority(10);
            });
        },
        blockBodyScroll() {
            // Verhindere Scrollen der Hintergrundseite
            if (process.client) {
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.width = '100%';
            }
        },
        unblockBodyScroll() {
            // Erlaube Scrollen der Hintergrundseite wieder
            if (process.client) {
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.width = '';
            }
        }
    },
    mounted() {
        this.$nuxt.$on('closeSidebars', () => this.closeSidebar());
    },
    beforeDestroy() {
        this.$nuxt.$off('closeSidebars', () => this.closeSidebar());
        if (this.backButtonHandler) {
            this.backButtonHandler();
            this.backButtonHandler = null;
        }
        
        // Sicherheitshalber alle Handler bereinigen
        BackButtonService.removeListenersWithPriority(10);
    }
}
